export default {_name:'progress.circle',module:'Field',view:'Element/Progress/Circle',options:{key:'progressCircle',value:'indeterminate',xs:'auto',ms:'auto'}}